/**
 * 
 * key
 * 
 */


const key = 'RG9jdW1lbnQ='

export default key 